import { render, staticRenderFns } from "./DropDownSelector.vue?vue&type=template&id=05497b66&scoped=true&"
import script from "./DropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./DropDownSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DropDownSelector.vue?vue&type=style&index=0&id=05497b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05497b66",
  null
  
)

export default component.exports